module.exports = __webpack_public_path__ + "app/assets/images/woman17-7cd2ab4eb74ca2a954e15b2a3e6d6edc.jpg";